import React from 'react';
import styled from 'styled-components';
import { colors } from '../styles/colors';

const ScheduleContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 2rem 1rem;
  width: 100%;
  background-color: ${colors.primary.lightTan};
  min-height: 100vh;
`;

const Title = styled.h1`
  font-family: 'saint-andrews-queen', serif;
  font-size: 10rem;
  text-align: center;
  margin-bottom: 1rem;
  color: ${colors.neutral.darkBrown};

  @media (max-width: 850px) {
    font-size: 6rem;
  }

  @media (max-width: 500px) {
    font-size: 4rem;
  }

  @media (max-width: 350px) {
    font-size: 3rem;
  }

  @media (max-width: 270px) {
    font-size: 2rem;
  }
`;

const Subheader = styled.h2`
  font-family: 'GremeryTwo', serif;
  font-size: 1.5rem;
  text-align: center;
  margin-bottom: 2rem;
  color: ${colors.neutral.darkBrown};
  letter-spacing: 0.2em;
`;

const ScheduleContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  max-width: 1000px;
  gap: 1rem;
`;

const DayIndicator = styled.div`
  font-family: 'GremeryOne', serif;
  font-size: 1.2rem;
  text-align: center;
  margin-bottom: 1rem;
  color: ${colors.neutral.darkBrown};
  font-weight: bold;
  letter-spacing: 0.1em;
  position: relative;
`;

const EventContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  max-width: 100%;
  margin-bottom: 1.5rem;
`;

const EventImage = styled.img`
  width: 120px;
  height: 120px;
  object-fit: contain;
  margin-bottom: 1rem;
`;

const EventTitle = styled.h3`
  font-family: 'GremeryTwo', serif;
  font-size: 1.3rem;
  margin-bottom: 0.5rem;
  color: ${colors.neutral.darkBrown};
  font-weight: bold;
  letter-spacing: 0.1em;
`;

const EventDetails = styled.p`
  font-family: 'GremeryTwo', serif;
  font-size: 1rem;
  color: ${colors.neutral.darkBrown};
  line-height: 1.4;
  white-space: nowrap;
`;

const EventMeta = styled.p`
  font-family: 'GremeryTwo', serif;
  font-size: 0.85rem;
  color: ${colors.neutral.darkBrown};
  margin-top: 0.5rem;
  opacity: 0.8;
  font-style: italic;
`;

const EventList = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1rem;
  width: 100%;
`;

const HorizontalVineSeparator = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  max-width: 90%;
  margin: 2.75rem 0 4.5rem 0;
  opacity: 0.5;
  height: 40px;
  overflow: hidden;

  @media (max-width: 768px) {
    height: 30px;
    max-width: 95%;
    margin: 2.2rem 0 3.5rem 0;
  }

  @media (max-width: 480px) {
    height: 25px;
    margin: 1.9rem 0 3rem 0;
  }
`;

const HorizontalVineSVG = styled.img`
  width: 100%;
  height: 100%;
  object-fit: contain;
  object-position: center;
`;

const WeddingSchedule: React.FC = () => {
  return (
    <ScheduleContainer id="schedule">
      <Title>The Weekend</Title>
      <Subheader>DETAILS</Subheader>
      
      <ScheduleContent>
        <EventList>
          <DayIndicator>THURSDAY - DECEMBER 3RD</DayIndicator>
          <EventContainer>
            <EventImage src="/images/marg-sketch.png" alt="Welcome Drinks" />
            <EventTitle>WELCOME DRINKS</EventTitle>
            <EventDetails>The Four Seasons Residences</EventDetails>
            <EventMeta>6:30 PM • Dress Code TBD</EventMeta>
          </EventContainer>

          <HorizontalVineSeparator>
            <HorizontalVineSVG src="/images/svgs/vines.svg" alt="Decorative vines" />
          </HorizontalVineSeparator>

          <DayIndicator>FRIDAY - DECEMBER 4TH</DayIndicator>
          <EventContainer>
            <EventImage src="/images/flamingo.png" alt="Pool Party" />
            <EventTitle>POOLSIDE LUNCH</EventTitle>
            <EventDetails>The Four Seasons Residences</EventDetails>
            <EventMeta>12:00 PM • Dress Code TBD</EventMeta>
          </EventContainer>

          <EventContainer>
            <EventImage src="/images/plate-sketch-02.png" alt="Rehearsal Dinner" />
            <EventTitle>REHEARSAL DINNER</EventTitle>
            <EventDetails>Coraluz at The Four Seasons</EventDetails>
            <EventMeta>6:00 PM • Dress Code TBD</EventMeta>
          </EventContainer>

          <HorizontalVineSeparator>
            <HorizontalVineSVG src="/images/svgs/vines.svg" alt="Decorative vines" />
          </HorizontalVineSeparator>

          <DayIndicator>SATURDAY - DECEMBER 5TH</DayIndicator>
          <EventContainer>
            <EventImage src="/images/rings-sketch.png" alt="Wedding Ceremony" />
            <EventTitle>WEDDING CEREMONY</EventTitle>
            <EventDetails>Terraza at The Four Seasons</EventDetails>
            <EventMeta>4:30 PM • Black Tie Preferred</EventMeta>
          </EventContainer>
          
          <EventContainer>
            <EventImage src="/images/flutes-sketch.png" alt="Cocktail Hour" />
            <EventTitle>COCKTAIL HOUR</EventTitle>
            <EventDetails>Terraza at The Four Seasons</EventDetails>
          </EventContainer>
          
          <EventContainer>
            <EventImage src="/images/dancers-sketch.png" alt="Dinner and Dancing" />
            <EventTitle>DINNER AND DANCING</EventTitle>
            <EventDetails>Terraza at The Four Seasons</EventDetails>
          </EventContainer>

          <EventContainer>
            <EventImage src="/images/disco-ball-sketch.png" alt="After Party" />
            <EventTitle>AFTER PARTY</EventTitle>
            <EventDetails>Terraza at The Four Seasons</EventDetails>
          </EventContainer>
        </EventList>
      </ScheduleContent>
    </ScheduleContainer>
  );
};

export default WeddingSchedule;
